import { useState } from 'react';

import Modal from '../../../../components/UI/Modals/Modal';
import {
  IWorkingHours,
  selectWorkingHours,
  updateWorkingHoursState,
} from '../../../../store/slices/calendarAndSlots';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import classes from '../OpeningHours/OpeningHoursModal.module.css';
import CustomDropdown from '../../../../components/UI/Inputs/CustomDropdown';
import PrimaryButtonV2 from '../../../../components/UI/Buttons/PrimaryButtonV2';
import { weekdayFromStringToNumber } from '../../../../utils/calendarUtils';
import { useTranslation } from '../../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const WorkingHoursModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [weekDay, setWeekDay] = useState('');
  const workingHours = useAppSelector<IWorkingHours[]>(selectWorkingHours);
  let calendarData = Array(workingHours);
  let calendarItems = [...calendarData[0]];
  const handleAdd = async () => {
    calendarItems.push({
      weekday_id: weekdayFromStringToNumber(weekDay),
      start_time: from + ':00',
      end_time: to + ':00',
    });
    let dataToPost = [calendarItems];
    dispatch(updateWorkingHoursState(dataToPost[0]));
    onClose();
  };

  const options = [
    'choose.day',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      containerPadding="60px 10px 20px 10px"
      width="350px"
      header={translations('new.opening').toString()}
    >
      <div className={classes.modalContainer}>
        <div className={classes.inputContainer}>
          <CustomDropdown
            dropdownStyle={{
              width: 270,
            }}
            label={translations('day')}
            placeholder={translations('day')}
            onChange={(e) => setWeekDay(e.target.value)}
            options={options.map((option) => ({ id: option, label: translations(option) }))}
            value={weekDay}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('from')}</div>
          <input
            id="appt-time"
            type="time"
            name="appt-time"
            className={classes.textContainer}
            onChange={(e) => setFrom(e.target.value)}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('to')}</div>
          <input
            id="appt-time"
            type="time"
            name="appt-time"
            className={classes.textContainer}
            onChange={(e) => setTo(e.target.value)}
          />
        </div>
        <PrimaryButtonV2
          buttonStyle={{ width: 270, marginTop: 40, height: 50 }}
          text={translations('add')}
          containerStyle={{}}
          disabled={weekDay === '' || to === '' || from === ''}
          onClick={handleAdd}
        />
      </div>
    </Modal>
  );
};

export default WorkingHoursModal;
